// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"styles_pageContent__1oKan","menuLinkItem":"styles_menuLinkItem__19qNP"};